import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';

// Public pages
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Register from './pages/Register';
import RegisterChimney from './pages/RegisterChimney';
import Contact from './pages/Contact';

// Protected pages
import Dashboard from './pages/Dashboard';
import ChimneysList from './pages/ChimneysList';
import ChimneyProfile from './pages/ChimneyProfile';
import Appointments from './pages/Appointments';
import Chat from './pages/Chat';
import Review from './pages/Review';

// Chimney panel
import ChimneyDashboard from './pages/ChimneyDashboard';

// Admin panel
import AdminPanel from './pages/AdminPanel';

// Activation & claim chimney
import ActivateAccount from './pages/ActivateAccount';
import ClaimChimney from './pages/ClaimChimney';
import RequestClaimChimney from './pages/RequestClaimChimney';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/register-chimney" element={<RegisterChimney />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/chimneys" element={<ChimneysList />} />
          <Route path="/chimney/:id" element={<ChimneyProfile />} />
          <Route path="/activate/:uid/:token" element={<ActivateAccount />} />
          <Route path="/claim-chimney/:uid/:token" element={<ClaimChimney />} />
          <Route path="/request-claim-chimney" element={<RequestClaimChimney />} />

          {/* Protected routes */}
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/appointments"
            element={
              <PrivateRoute>
                <Appointments />
              </PrivateRoute>
            }
          />
          <Route
            path="/chat/:roomId"
            element={
              <PrivateRoute>
                <Chat />
              </PrivateRoute>
            }
          />
          <Route
            path="/review/:appointmentId"
            element={
              <PrivateRoute>
                <Review />
              </PrivateRoute>
            }
          />

          {/* Chimney panel */}
          <Route
            path="/chimney-dashboard"
            element={
              <PrivateRoute>
                <ChimneyDashboard />
              </PrivateRoute>
            }
          />

          {/* Admin panel */}
          <Route
            path="/admin-panel"
            element={
              <PrivateRoute>
                <AdminPanel />
              </PrivateRoute>
            }
          />

          {/* Catch all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
